/* jj-samsung-size-suggest.js — wrist-size recommendation logic for the Samsung
   watch-band PDPs. Lives in an asset (not inline in the snippet) so the Liquid
   parser never has to walk a large raw <script> node. Reads the size database
   from the <script id="jj-ss-db" type="application/json"> block rendered by
   snippets/samsung-size-suggest.liquid, and the custom-size page URL from the
   widget's data-custom-url attribute. */

(function(){
/* Run once per page, whatever happens.
   Symmetry's quick-buy modal RE-CREATES <script src> elements every time it
   injects product markup, so this file was executing several times over — each
   run adding its own MutationObserver and its own init. Two initialised
   widgets then fought over the same anchor row, each relocation triggering the
   other's observer: an infinite loop, and the browser's "page unresponsive"
   dialog. One run, one set of observers. */
if (window.__jjSSLoaded) return;
window.__jjSSLoaded = true;

/* One init PER widget copy.
   The widget used to assume it was the only one on the page and looked its
   parts up with document.getElementById. With a quick view open on a Samsung
   PDP there are two copies, and every one of those lookups resolves to the
   FIRST — so the quick view's script would silently drive the product page's
   widget. Each init now binds to its own wrapper and looks up inside it. */
function jjSSInit(wrap){
  if(!wrap || wrap.dataset.init) return;
  wrap.dataset.init = '1';

  // Quick view copy? Then the option rows are the QV's selects, not Symmetry's
  // <variant-picker>, and the widget must not relocate itself.
  var QV = wrap.closest('.jj-qv');
  if (!QV && wrap.closest('[data-jj-ss-keep]')) QV = wrap.closest('[data-jj-ss-keep]');
  function pick(sel){ return wrap.querySelector(sel) || document.querySelector(sel); }

  /* Database: the data attribute first. Symmetry's quick-buy modal injects
     markup with innerHTML, which re-creates <script src> but drops inline
     <script> blocks — so the JSON element is often gone there, while
     attributes always survive. */
  var dbEl = wrap.querySelector('#jj-ss-db, [data-qv-ss-db]') || document.getElementById('jj-ss-db');
  var DB = JSON.parse(wrap.dataset.ssDb || (dbEl ? dbEl.textContent : 'null'));
  if (!DB || !DB.models) { delete wrap.dataset.init; return; }
  var TOL = DB.tolerance;
  // No underscore prefix: underscore properties are hidden from the Shopify
  // order details too. A visible key lets quality checks read the wrist size
  // on every Samsung order.
  var PROP_NAME = 'properties[Polsomtrek (cm)]';
  var MSG_REQUIRED = '*Vul eerst je polsomtrek in cm in.';
  var MSG_INVALID  = '*Vul een geldige polsomtrek in tussen 10 en 25 cm.';
  var MSG_SIZE     = '*Kies je maat (S, M of L) in het Maat-menu.';
  var PLACEHOLDER_TXT = 'Kies je maat';
  var SIZE_OPTION_NAMES = ['Maat','Size']; // option-name candidates for the size row
  var MODEL_OPTION_NAMES = ['Watch model','Model']; // anchor row for the widget
  // Mandatory measurement: when the wrapper carries data-require-measure, the
  // Maat picker is blocked until a suggestion has been calculated.
  var REQUIRE_MEASURE = wrap.dataset.requireMeasure === 'true';
  var measured = false;
  // custom-size page if present in the shop, otherwise null → mailto fallback
  var CUSTOM_URL = wrap.dataset.customUrl || null;

  var input  = pick('#jj-ss-wrist');
  var btn    = pick('#jj-ss-calc');
  var errEl  = pick('#jj-ss-err');
  var result = pick('#jj-ss-result');
  var rangesBox   = pick('#jj-ss-ranges');
  var rangesTitle = pick('#jj-ss-ranges-title');
  var rangesBody  = pick('#jj-ss-ranges-body');

  /* ── SYMMETRY: locate the "Maat" option row ─────────────────────────
     Primary: .option-selector[data-option="Maat"|"Size"].
     Fallback: any option-selector whose label/legend starts with "Maat". */
  /* In the quick view the "rows" are the QV's own option groups; on a product
     page they are Symmetry's option-selectors. Both are resolved here so the
     rest of the widget does not care which context it runs in. */
  /* A quick-buy MODAL copy must read the modal's own picker. This narrowing
     applies only inside a modal — on a plain product page the search stays
     document-wide, which is what kept the widget anchored correctly there. */
  function pickerRoot(){
    return wrap.closest('.quickbuy, quick-buy-modal, .modal, [data-name="quickbuy"]') || document;
  }
  function findRow(sel){
    var root = pickerRoot();
    return root.querySelector(sel) || (root !== document ? document.querySelector(sel) : null);
  }
  function qvRow(attr){
    if(!QV) return null;
    var el = QV.querySelector(attr);
    return el ? el.closest('[data-qv-optgroup]') || el.parentNode : null;
  }
  function maatContainer(){
    if(QV) return qvRow('[data-qv-ss-size]');
    for(var i=0;i<SIZE_OPTION_NAMES.length;i++){
      var el = findRow('variant-picker .option-selector[data-option="'+SIZE_OPTION_NAMES[i]+'"]');
      if(el) return el;
    }
    var rows = pickerRoot().querySelectorAll('variant-picker .option-selector');
    if(!rows.length) rows = document.querySelectorAll('variant-picker .option-selector');
    for(var j=0;j<rows.length;j++){
      var lab = rows[j].querySelector('.label, legend');
      if(lab && /^maat\b/i.test((lab.textContent||'').trim())) return rows[j];
    }
    return null;
  }
  function modelContainer(){
    if(QV) return qvRow('[data-qv-ss-model]');
    for(var i=0;i<MODEL_OPTION_NAMES.length;i++){
      var el = findRow('variant-picker .option-selector[data-option="'+MODEL_OPTION_NAMES[i]+'"]');
      if(el) return el;
    }
    var rows = pickerRoot().querySelectorAll('variant-picker .option-selector');
    if(!rows.length) rows = document.querySelectorAll('variant-picker .option-selector');
    for(var j=0;j<rows.length;j++){
      var lab = rows[j].querySelector('.label, legend');
      if(lab && /model/i.test((lab.textContent||'').trim())) return rows[j];
    }
    return null;
  }
  function maatType(){ // 'dropdown' | 'listed' | null
    var c = maatContainer();
    return c ? (c.getAttribute('data-selector-type') || (c.querySelector('custom-select') ? 'dropdown' : 'listed')) : null;
  }
  function maatSelectedValue(){
    var c = maatContainer();
    if(!c) return null; // no Maat row on page → size gating disabled (fail-open)
    if(maatType() === 'dropdown'){
      var opt = c.querySelector('.custom-select__option[aria-selected="true"]');
      return opt ? (opt.dataset.value || '') : '';
    }
    var checked = c.querySelector('input.js-option:checked');
    return checked ? checked.value : '';
  }

  /* ── relocate the widget so it sits directly ABOVE the Maat row ──
     The theme editor can only place this block below the whole buy-buttons
     block; this lifts it up. Set RELOCATE=false to keep it in place.
     A MutationObserver re-inserts the same node (entered value intact)
     if the theme ever re-renders the picker HTML. */
  var RELOCATE = true;
  function dedupe(){
    // Stand down once our own node is gone: closing a quick-buy modal and
    // opening another leaves this init orphaned, and an orphan that keeps
    // policing the DOM would delete the NEXT modal's copy before it can
    // initialise. The bootstrap at the bottom of this file takes over.
    if(!wrap.isConnected || wrap.offsetParent === null) return;
    // The theme re-renders the product info on variant change, which can bring
    // back a fresh copy of this widget's markup while our (moved) node lives on.
    // Keep the initialised one, drop any others.
    var all = document.querySelectorAll('.jj-ss-wrap');
    for (var d = 0; d < all.length; d++) {
      if (all[d] === wrap || all[d].dataset.init) continue;
      // A quick view legitimately renders its OWN copy — never remove that
      // one. Without this the page's widget eats the quick view's copy the
      // instant it is injected, before it can even initialise.
      if (all[d].closest('.jj-qv, [data-jj-ss-keep]')) continue;
      all[d].parentNode && all[d].parentNode.removeChild(all[d]);
    }
  }
  function relocate(){
    if(!RELOCATE || QV) return; // the QV renders the widget already in place
    // A widget in a closed modal is still in the DOM; it must not move rows or
    // delete the copy belonging to the modal that is actually open.
    if(!wrap.isConnected || wrap.offsetParent === null) return;
    dedupe();
    // Below the Watch model row (the model must be known before a size can be
    // suggested); the Maat row remains the fallback if no model row exists.
    var target = modelContainer() || maatContainer();
    if(!target || target.nextElementSibling === wrap) return;
    target.parentNode.insertBefore(wrap, target.nextSibling);
  }
  var relocating = false;
  function relocateSafe(){
    // The observers below fire on the very mutation relocate() causes, so keep
    // the move non-re-entrant as well as idempotent.
    if(relocating) return;
    relocating = true;
    try { relocate(); } finally { relocating = false; }
  }
  relocateSafe();
  new MutationObserver(function(){ relocateSafe(); }).observe(document.body, { childList: true, subtree: true });
  // The widget now sits INSIDE <variant-picker>; internal events (e.g. the
  // 'change' a text field fires on blur) must not reach the theme JS, or it
  // runs its variant logic against our widget. Stop them at the widget edge.
  ['change','input'].forEach(function(evt){
    wrap.addEventListener(evt, function(e){ e.stopPropagation(); });
  });

  /* ── "Kies je maat" placeholder ──────────────────────────────────────
     Deep links with ?variant= skip the placeholder (customer arrived with
     a deliberate size). Otherwise:
       dropdown → overwrite the custom-select button TEXT only (component
                  internals untouched; theme still holds variant 1, which
                  our ATC gating prevents from being ordered).
       listed   → uncheck the preselected radio programmatically (fires no
                  change event, so the theme's variant logic is undisturbed).
     sizeChosen flips to true on the customer's first real Maat interaction. */
  // Option A (18 Aug): this widget RECOMMENDS only. The JJ Variant gate owns
  // de-selection and add-to-cart blocking, so the legacy placeholder and ATC
  // gating below are switched off by starting in the "size chosen" state.
  var sizeChosen = true;
  var memoRadio = null; // originally checked radio (listed type), for the capture-restore trick

  function applyPlaceholder(){
    if(sizeChosen) return;
    var c = maatContainer();
    if(!c) return;
    if(maatType() === 'dropdown'){
      var b = c.querySelector('.custom-select__btn');
      if(b && b.firstElementChild && b.firstElementChild.textContent !== PLACEHOLDER_TXT){
        b.firstElementChild.textContent = PLACEHOLDER_TXT;
        b.classList.add('jj-ss-ph');
      }
    } else {
      var checked = c.querySelector('input.js-option:checked');
      if(checked){ memoRadio = checked; checked.checked = false; }
    }
  }
  function clearPlaceholderState(){
    sizeChosen = true;
    var c = maatContainer();
    if(c){
      var b = c.querySelector('.custom-select__btn');
      if(b) b.classList.remove('jj-ss-ph');
      c.classList.remove('jj-ss-maat-alert');
    }
    hideSizeErr();
  }
  applyPlaceholder();

  // Detect the customer's first real Maat interaction (both picker types).
  document.addEventListener('click', function(e){
    if(sizeChosen) return;
    var c = maatContainer();
    if(!c || !c.contains(e.target)) return;
    var opt = e.target.closest('.custom-select__option, label.opt-label, input.js-option');
    if(opt) setTimeout(function(){ if(maatSelectedValue()) clearPlaceholderState(); syncLock(); }, 0);
  }, true);
  document.addEventListener('change', function(e){
    if(sizeChosen) return;
    var c = maatContainer();
    if(c && c.contains(e.target) && maatSelectedValue()) { clearPlaceholderState(); syncLock(); }
  }, true);

  // Listed type only: if ANOTHER option changes while Maat is still empty,
  // hand the theme its original radio for the computation, then re-clear.
  document.addEventListener('change', function(e){
    if(sizeChosen || maatType() !== 'listed' || !memoRadio) return;
    var c = maatContainer();
    var vp = document.querySelector('variant-picker');
    if(!vp || !vp.contains(e.target)) return;
    if(c && c.contains(e.target)) return; // it IS the Maat row → handled above
    memoRadio.checked = true;
    setTimeout(function(){ if(!sizeChosen && memoRadio){ memoRadio.checked = false; } }, 0);
  }, true);

  // Re-apply placeholder + relocation after theme re-renders.
  new MutationObserver(function(){
    /* Must test the SAME anchor relocate() uses. This used to require the
       widget to sit directly above the "Maat" row, which contradicted the
       move to below the "Watch model" row as soon as a third option (Kleur)
       existed: this observer pushed the widget one way, relocate() put it
       back, and each move re-triggered the other — the page freeze. */
    var anchor = modelContainer() || maatContainer();
    if(!document.body.contains(wrap) || (anchor && anchor.nextElementSibling !== wrap)){
      relocateSafe();
    }
    applyPlaceholder();
  }).observe(document.body, {childList:true, subtree:true, characterData:true});

  /* ── helpers ── */
  function norm(s){ return (s||'').toLowerCase().replace(/[()]/g,'').replace(/\s+/g,' ').replace(/(\d)\s*mm/g,'$1mm').trim(); }
  var MODEL_INDEX = {};
  Object.keys(DB.models).forEach(function(k){ MODEL_INDEX[norm(k)] = k; });
  function fmt(n){ return n.toFixed(2).replace(/0$/,'').replace('.',','); }
  function parseWrist(){
    var v = parseFloat((input.value||'').replace(/,/g,'.'));
    return (v && v >= 10 && v <= 25) ? v : null;
  }
  function filled(){ return (input.value||'').trim() !== ''; }

  /* ── find the currently selected watch model ──
     Scans every option row; any selected value matching the database wins
     (no dependency on the model option's name). */
  function selectedModel(){
    if(QV){
      var ms = QV.querySelector('[data-qv-ss-model]');
      return ms ? (MODEL_INDEX[norm(ms.value)] || null) : null;
    }
    var rows = pickerRoot().querySelectorAll('variant-picker .option-selector');
    if(!rows.length) rows = document.querySelectorAll('variant-picker .option-selector');
    for(var i=0;i<rows.length;i++){
      var val;
      if((rows[i].getAttribute('data-selector-type')||'') === 'dropdown' || rows[i].querySelector('custom-select')){
        var opt = rows[i].querySelector('.custom-select__option[aria-selected="true"]');
        val = opt ? opt.dataset.value : null;
        // The JJ variant gate clears the visible choice ("Kies een optie") while
        // the component may still mark its original option as selected. Trust
        // what the customer can SEE: if the button text no longer matches the
        // marked option, nothing is really chosen.
        var btnEl = rows[i].querySelector('.custom-select__btn');
        var btnTxt = btnEl ? (btnEl.textContent || '').trim() : '';
        if (val && btnTxt && norm(btnTxt) !== norm(val)) val = null;
        if (opt && (opt.dataset.value || '') === '') val = null;
      } else {
        var checked = rows[i].querySelector('input.js-option:checked');
        val = checked ? checked.value : null;
      }
      var key = MODEL_INDEX[norm(val)];
      if(key) return key;
    }
    return null;
  }

  /* ── hidden line-item property, kept in sync in every ATC form ── */
  function syncProperty(){
    /* Scope matters once two copies exist: the quick view's measurement must
       land on the quick view's form, and the product page's on the page form.
       Writing to every cart form would cross-contaminate the two orders. */
    var SEL = 'form[action*="/cart/add"], form[data-type="add-to-cart-form"]';
    var forms = QV ? QV.querySelectorAll(SEL)
                   : Array.prototype.filter.call(document.querySelectorAll(SEL), function(f){
                       return !f.closest('.jj-qv');
                     });
    forms.forEach(function(f){
      var h = f.querySelector('input[name="'+PROP_NAME.replace(/"/g,'\\"')+'"]');
      if(!h){
        h = document.createElement('input');
        h.type = 'hidden';
        h.name = PROP_NAME;
        f.appendChild(h);
      }
      h.value = (input.value||'').trim().replace(/\./g,',');
      h.disabled = h.value === ''; // a disabled input never submits: no empty property
    });
  }

  /* ── ranges table for a model ── */
  function renderRanges(modelKey, suggested, hlClass){
    var m = DB.models[modelKey];
    rangesTitle.textContent = 'Maattabel — ' + modelKey;
    rangesBody.innerHTML = '';
    ['S','M','L'].forEach(function(sz){
      var tr = document.createElement('tr');
      if(suggested && suggested.indexOf(sz) !== -1) tr.className = hlClass || 'jj-ss-hl';
      tr.innerHTML = '<td>'+sz+'</td><td>Past bij polsomtrek '+fmt(m[sz][0])+' – '+fmt(m[sz][1])+' cm</td>';
      rangesBody.appendChild(tr);
    });
    rangesBox.classList.add('show');
  }

  /* ── diagnostics: run jjSizeDebug() in the browser console ── */
  window.jjSizeDebug = function () {
    var rows = document.querySelectorAll('variant-picker .option-selector');
    var mcDbg = maatContainer();
    return {
      widgetFound: !!wrap,
      assetRunning: true,
      requireMeasure: REQUIRE_MEASURE,
      measured: measured,
      measureLocked: measureLocked(),
      maatRowLocked: mcDbg ? mcDbg.classList.contains('jj-ss-maat-locked') : null,
      maatRowFound: !!mcDbg,
      dbModels: Object.keys(DB.models || {}).length,
      pickerRows: rows.length,
      rowValues: Array.prototype.map.call(rows, function (r) {
        var lab = r.querySelector('.label, legend');
        var opt = r.querySelector('.custom-select__option[aria-selected="true"]');
        var checked = r.querySelector('input.js-option:checked');
        return {
          label: lab ? lab.textContent.trim().slice(0, 30) : '(none)',
          type: (r.getAttribute('data-selector-type') || (r.querySelector('custom-select') ? 'dropdown' : 'listed')),
          value: opt ? opt.dataset.value : (checked ? checked.value : null),
          buttonText: (function () {
            var b = r.querySelector('.custom-select__btn');
            return b ? (b.textContent || '').trim().slice(0, 30) : null;
          })()
        };
      }),
      selectedModel: selectedModel(),
      wristValue: input.value,
      resultClass: result.className,
      resultText: (result.textContent || '').slice(0, 60),
      resultVisible: getComputedStyle(result).display !== 'none',
      errClass: errEl.className,
      errVisible: getComputedStyle(errEl).display !== 'none'
    };
  };

  /* ── main suggestion logic ── */
  function suggest(){
    var modelKey = selectedModel();
    result.className = 'jj-ss-result';
    if(!modelKey){
      result.className = 'jj-ss-result show res-warn';
      result.innerHTML = '<span class="jj-ss-rtitle">Kies eerst je watch model</span>Selecteer hierboven jouw Samsung watch model, dan berekenen we de juiste maat.';
      rangesBox.classList.remove('show');
      return;
    }
    var v = parseWrist();
    if(!v){
      result.className = 'jj-ss-result show res-err';
      result.innerHTML = '<span class="jj-ss-rtitle">Ongeldige invoer</span>Vul een polsomtrek in tussen 10 en 25 cm.';
      rangesBox.classList.remove('show');
      return;
    }
    // A real measurement was computed for a chosen model — the Maat picker
    // unlocks from here. The out-of-range branch counts too: the customer HAS
    // measured.
    measured = true;
    wrap.classList.remove('jj-ss-nudge');
    var mc0 = maatContainer();
    if(mc0) mc0.classList.remove('jj-ss-maat-locked');
    if(QV){
      // The quick view gates its size <select> natively rather than by click
      // blocking; a completed measurement is what releases it.
      var qs = QV.querySelector('[data-qv-ss-size]');
      if(qs){ qs.disabled = false; qs.removeAttribute('data-qv-ss-locked'); }
      var qh = QV.querySelector('[data-qv-ss-hint]');
      if(qh) qh.hidden = true;
    }
    var m = DB.models[modelKey];
    var lo = m.S[0], smBorder = m.S[1], mlBorder = m.M[1], hi = m.L[1];
    var html, cls, hl;

    if(v < lo - TOL || v > hi){
      cls = 'res-warn';
      hl = null;
      var route = CUSTOM_URL
        ? 'Vraag \u2019m aan via onze <a href="'+CUSTOM_URL+'" style="color:inherit;font-weight:700;">custom-maat pagina</a>'
        : 'Mail ons via <a href="mailto:klantenservice@jouw-juweeltjes.nl" style="color:inherit;font-weight:700;">klantenservice@jouw-juweeltjes.nl</a>';
      html = '<span class="jj-ss-rtitle">Jouw polsomtrek valt buiten onze standaardmaten voor dit model.</span>'
           + 'Geen zorgen — we maken graag een <strong>aangepaste maat</strong> op jouw exacte polsomtrek, voor een meerprijs van <strong>\u20ac5,00</strong>. '
           + route + ' en we regelen het voor je.';
    } else if(v >= smBorder - TOL && v <= smBorder + TOL){
      cls = 'res-both'; hl = ['S','M'];
      html = '<span class="jj-ss-rtitle">Tussen maat S en M in</span>Jouw polsomtrek van <strong>'+fmt(v)+' cm</strong> zit bij dit model op de grens van <strong>S</strong> en <strong>M</strong>. Beide passen — kies <strong>S</strong> voor een strakkere fit of <strong>M</strong> voor een lossere fit.';
    } else if(v >= mlBorder - TOL && v <= mlBorder + TOL){
      cls = 'res-both'; hl = ['M','L'];
      html = '<span class="jj-ss-rtitle">Tussen maat M en L in</span>Jouw polsomtrek van <strong>'+fmt(v)+' cm</strong> zit bij dit model op de grens van <strong>M</strong> en <strong>L</strong>. Beide passen — kies <strong>M</strong> voor een strakkere fit of <strong>L</strong> voor een lossere fit.';
    } else {
      // Unambiguous size: no note box, just the green highlight in the table.
      var sz = v < smBorder ? 'S' : (v < mlBorder ? 'M' : 'L');
      result.className = 'jj-ss-result';
      result.innerHTML = '';
      renderRanges(modelKey, [sz], 'jj-ss-hl-ok');
      return;
    }
    result.className = 'jj-ss-result show ' + cls;
    result.innerHTML = html;
    renderRanges(modelKey, hl);
  }

  /* ── info tooltip: hover on desktop (CSS), tap/click toggle everywhere ── */
  var info = pick('#jj-ss-info');
  info.addEventListener('click', function(e){
    e.preventDefault();
    var open = info.classList.toggle('is-open');
    info.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.addEventListener('click', function(e){
    if(!info.contains(e.target)){ info.classList.remove('is-open'); info.setAttribute('aria-expanded','false'); }
  });

  /* ── events ── */
  btn.addEventListener('click', suggest);

  /* ── mandatory measurement ──────────────────────────────────────────
     While enabled and nothing has been measured yet, attempts to pick a size
     are stopped in the capture phase (before the custom-select opens or a
     radio flips) and the widget explains why. Deep links with ?variant=
     arrive with a deliberate size and are exempt. Fail-open by design: no
     Maat row, or no widget visible → no blocking. */
  var DEEP_LINKED = /[?&]variant=/.test(location.search);
  function measureLocked(){
    if(QV) return false; // the QV disables its size select instead
    if(!REQUIRE_MEASURE || measured || DEEP_LINKED) return false;
    if(wrap.offsetParent === null) return false;
    return true;
  }
  var SG_TRIGGERS = 'a, .size-chart-link, open-or-scroll-to, [data-qv-sizeguide],'
    + ' .jj-sg2-btn, .jj-ap-btn, .jj-fb-btn, .jj-ob-btn, .jj-easify-size-link,'
    + ' [class*="size-guide"], [class*="sizeguide"], [class*="maatgids"], [data-size-guide]';
  function nudge(){
    result.className = 'jj-ss-result show res-warn';
    result.innerHTML = '<span class="jj-ss-rtitle">Meet eerst je pols</span>Vul hierboven je polsomtrek in — dan zien we direct welke maat het beste past.';
    wrap.classList.add('jj-ss-nudge');
    if(input){ try{ input.focus({ preventScroll: true }); }catch(err){ input.focus(); } }
    wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  /* THE SIZE-GUIDE FIX. The size-guide trigger sits INSIDE this same option
     row (Symmetry renders size_chart_link within the option row, and the JJ
     popup snippets add their own button there). Blocking the whole row
     therefore swallowed it, and the customer got the "meet eerst je pols"
     nudge instead of the size guide — while the guide is exactly what an
     unmeasured customer needs. Every size-guide trigger, and any plain link,
     is let through; only the size CHOICE itself is blocked. */
  /* Belt AND braces. The capture-phase blockers below are the original
     mechanism, but they demonstrably do not engage inside Symmetry's
     quick-buy modal, so the size row is ALSO locked structurally: the
     controls stop receiving pointer events until a measurement exists. That
     is the same approach the quick view uses (where it simply disables its
     <select>), and it does not depend on event ordering at all. Clicking the
     locked row still nudges, because the lock sits on the inner controls
     while the row itself stays clickable. */
  function syncMeasureLock(){
    var c = maatContainer();
    if(!c) return;
    var locked = measureLocked();
    c.classList.toggle('jj-ss-maat-locked', locked);
    if(locked && !c.dataset.jjSsNudge){
      c.dataset.jjSsNudge = '1';
      c.addEventListener('click', function(e){
        if(!measureLocked()) return;
        if(e.target.closest && e.target.closest(SG_TRIGGERS)) return;
        nudge();
      });
    }
  }
  syncMeasureLock();
  document.addEventListener('change', function(){ setTimeout(syncMeasureLock, 0); }, true);
  document.addEventListener('click', function(){ setTimeout(syncMeasureLock, 0); }, true);

  ['pointerdown','mousedown','click','keydown'].forEach(function(evt){
    document.addEventListener(evt, function(e){
      if(!measureLocked()) return;
      if(evt === 'keydown' && ['Enter',' ','ArrowDown','ArrowUp'].indexOf(e.key) === -1) return;
      var c = maatContainer();
      if(!c || !c.contains(e.target)) return;
      if(wrap.contains(e.target)) return;
      if(e.target.closest && e.target.closest(SG_TRIGGERS)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if(evt === 'click') nudge();
    }, true);
  });
  input.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); suggest(); } });
  input.addEventListener('input', function(){
    input.classList.remove('jj-ss-invalid');
    errEl.classList.remove('is-visible');
    syncProperty();
  });
  // Re-run when the customer switches watch model (any picker type).
  document.addEventListener('change', function(e){
    var t = e.target;
    if(!t || !t.closest) return;
    /* The quick view has no <variant-picker> — its options are plain selects —
       so this listener never fired there and choosing a model did nothing.
       Each copy reacts to option changes in ITS OWN context only. */
    var inPicker = QV ? (QV.contains(t) && t.closest('[data-qv-optgroup], [data-qv-select], [data-qv-opt]'))
                      : t.closest('variant-picker');
    if(!inPicker) return;
    var isModelRow = QV ? !!t.closest('[data-qv-ss-model]')
                        : (modelContainer() ? modelContainer().contains(t) : false);
    if(filled()){
      suggest();
    } else if(isModelRow && selectedModel() && wrap.dataset.measured !== '1'){
      // Model chosen, nothing measured yet → hand the customer the next step
      // rather than leaving them to notice the field on their own.
      try { input.focus({ preventScroll: true }); } catch(err) { input.focus(); }
    }
    syncProperty(); // sticky-ATC forms may (re)render on variant change
  });
  syncProperty();
  setTimeout(syncProperty, 1500); // catch the late-rendered sticky ATC form

  /* ── legacy ATC blocking, retired 18 Aug ──────────────────────────────
     The JJ Variant gate now blocks add-to-cart until every option is chosen,
     and (on templates that need it) until app fields are filled. Two blockers
     on one button fight each other, so this one always reports "ok".
     Set LEGACY_ATC_GATING = true to restore the old behaviour. */
  var LEGACY_ATC_GATING = false;
  function sizeOk(){
    if(!LEGACY_ATC_GATING) return true;
    if(!maatContainer()) return true;          // no Maat row → fail-open
    return sizeChosen && maatSelectedValue() !== '';
  }
  function ok(){
    if(!LEGACY_ATC_GATING) return true;
    return parseWrist() !== null && sizeOk();
  }
  function syncLock(){ document.body.classList.toggle('jj-ss-locked', !ok()); }
  function hideSizeErr(){ errEl.classList.remove('is-visible'); }
  function showErr(){
    input.classList.remove('jj-ss-invalid');
    errEl.classList.remove('is-visible');
    if(parseWrist() === null){
      errEl.textContent = filled() ? MSG_INVALID : MSG_REQUIRED;
      errEl.classList.add('is-visible');
      input.classList.add('jj-ss-invalid');
      if(wrap.scrollIntoView) wrap.scrollIntoView({behavior:'smooth', block:'center'});
      input.focus();
      return;
    }
    // Wrist ok → size missing.
    errEl.textContent = MSG_SIZE;
    errEl.classList.add('is-visible');
    var mc = maatContainer();
    if(mc){
      mc.classList.add('jj-ss-maat-alert');
      if(mc.scrollIntoView) mc.scrollIntoView({behavior:'smooth', block:'center'});
    }
  }
  input.addEventListener('input', syncLock);
  document.addEventListener('change', syncLock);
  syncLock();

  document.addEventListener('submit', function(e){
    var f = e.target;
    var isAtc = (f.matches && f.matches('[data-type="add-to-cart-form"]')) ||
                f.querySelector('[name="add"]') ||
                (f.action && f.action.indexOf('/cart/add') !== -1);
    if(isAtc && !ok()){
      e.preventDefault();
      e.stopImmediatePropagation();
      showErr();
    } else if(isAtc){
      syncProperty();
    }
  }, true);
  // SYMMETRY: main form + sticky-atc both render `.add-to-cart[name="add"]`.
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[name="add"], .add-to-cart');
    if(b && !ok()){
      e.preventDefault();
      e.stopImmediatePropagation();
      showErr();
    }
  }, true);
}

/* Bootstrap: initialise every widget copy present now, and any that appears
   later — the quick view injects its copy long after this asset has run. */
function jjSSInitAll(){
  /* Copies that own a scope of their own (quick view, keep-marked) each get an
     init and never relocate. Of the REST — the page's or the modal's widget —
     only one may be live: a second relocating widget is what causes anchor
     ping-pong. Any extra is left for dedupe to clear. */
  var free = [];
  document.querySelectorAll('.jj-ss-wrap:not([data-init])').forEach(function (w) {
    if (w.closest('.jj-qv, [data-jj-ss-keep]')) { free.push(w); return; }
    /* Only a VISIBLE initialised widget blocks another from initialising.
       Being in the DOM is not enough: Symmetry keeps a closed quick-buy modal
       in the document, so the previous product's widget stayed "connected"
       and this gate skipped the newly opened modal's widget — leaving the
       visible one dead (no lock, no focus, calculate button inert). */
    var blocked = false;
    document.querySelectorAll('.jj-ss-wrap[data-init]').forEach(function (o) {
      if (o === w || o.closest('.jj-qv, [data-jj-ss-keep]')) return;
      if (o.isConnected && o.offsetParent !== null) blocked = true;
    });
    if (!blocked) free.push(w);
  });
  free.forEach(function (w) {
    try {
      jjSSInit(w);
    } catch (err) {
      /* data-init is set on the first line of the init, so a throw partway
         used to leave a copy that LOOKED initialised while relocation, the
         measurement lock and the diagnostics had never run. Clearing the flag
         lets the next pass retry, and the warning names the real cause. */
      delete w.dataset.init;
      if (window.console) console.warn('[jj-size-suggest] init failed, will retry', err);
    }
  });
}
jjSSInitAll();
new MutationObserver(jjSSInitAll).observe(document.body, { childList: true, subtree: true });
window.jjSSInit = jjSSInitAll;
})();